import { render, staticRenderFns } from "./OrganisationBulkUserForm.vue?vue&type=template&id=c461b5dc&scoped=true"
import script from "./OrganisationBulkUserForm.vue?vue&type=script&lang=js"
export * from "./OrganisationBulkUserForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c461b5dc",
  null
  
)

export default component.exports